var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 426,
    viewBox: "0 0 425 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1689 223.436V56.9929C36.1689 48.6291 42.9563 41.8516 51.3322 41.8516H369.665C378.041 41.8516 384.828 48.6291 384.828 56.9929V78.9973",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.645 313.137L273.417 82.5234H114.51L190.187 320.855C194.45 334.287 184.411 347.986 170.301 347.986H321.094C339.221 347.986 352.122 330.388 346.639 313.137H346.645Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.187 320.855L114.51 82.5234H102.871L115.227 121.432L128.507 163.251L178.779 321.57C180.587 327.269 176.329 333.08 170.339 333.08H155.534C151.677 333.08 148.26 330.586 147.094 326.911L95.1266 163.251H83.4399L136.172 329.314C139.702 340.434 150.035 347.986 161.717 347.986H170.301C184.411 347.986 194.456 334.287 190.187 320.855Z",
    fill: "#A3C5EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.528 333.079H170.333C176.324 333.079 180.581 327.268 178.773 321.57L128.502 163.25H95.1213L147.088 326.91C148.254 330.585 151.667 333.079 155.528 333.079Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.871 82.5234L115.227 121.432L102.871 82.5234Z",
    fill: "#6F7C87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.289 91.5709L273.417 82.5234H102.871L178.773 321.565C180.581 327.264 176.324 333.074 170.333 333.074H155.528C151.672 333.074 148.254 330.58 147.088 326.906L95.1213 163.245",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.411 304.879L136.172 329.314C139.702 340.433 150.035 347.985 161.717 347.985H321.094C339.221 347.985 352.122 330.387 346.639 313.136L298.213 160.633",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.502 163.242H83.4399L109.119 244.119",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.51 82.5234L190.187 320.855C194.45 334.287 184.411 347.986 170.301 347.986",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.418 109.883H257.082",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M161.663 179.938H279.327",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.429 191.789H287.634",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.088 121.43H268.662",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.123 168.781H283.697",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.226 203.75H248.075",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.894 281.445H311.558",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M197.659 293.289H319.864",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.457 305.25H280.306",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154.683 157.945H260.088",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.543 132.312H237.613",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.837 230.875H283.697",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M181.507 242.422H307.081",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M184.962 253.312H301.449",
    stroke: "#F39200",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.858 183.609H134.968",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.661 195.57H138.766",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M143.328 273.266H163.439",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.088 285.109H167.199",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.891 297.078H170.997",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.272 222.703H147.382",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M130.941 234.25H151.046",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M134.396 245.133H154.507",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M109.119 244.124C112.269 254.047 104.85 264.163 94.4313 264.163H51.5783C43.0686 264.163 36.1689 271.053 36.1689 279.55V374.869C36.1689 383.233 42.9563 390.01 51.3322 390.01H369.665C378.041 390.01 384.828 383.233 384.828 374.869V135.112C384.828 126.614 377.929 119.725 369.419 119.725L296.512 119.741C289.794 119.741 283.852 115.398 281.82 109.005L276.284 91.5781",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.d3f2a219.svg";
export { ForwardRef as ReactComponent };